// @flow
import React from 'react';
import { Link } from 'react-router-dom';

// Material
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';

const useStyles = makeStyles(theme => ({
  root: {
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(2, 0),
  },
}));

type Props = {
  links?: Array<Object>,
};

type BreadCrumbLink = {
  url: string,
  name: string,
};

export default function SimpleBreadcrumbs({ links = [] }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Breadcrumbs aria-label="breadcrumb">
        <Link to="/">Naexguide</Link>
        {links.map((link: BreadCrumbLink) => {
          if (!link.url) {
            return (
              <Typography key={link.name} color="textPrimary">
                {link.name}
              </Typography>
            );
          } else {
            return (
              <Link key={link.name} to={link.url}>
                {link.name}
              </Link>
            );
          }
        })}
      </Breadcrumbs>
    </div>
  );
}
